import { Images } from 'assets/images';
import { useEffect, useState } from 'react';
import ReactDatePicker from 'react-datepicker';
import {
  CalendarContent,
  QuestionText,
  CustomInput,
  ExampleCustomInput,
  CalendarIcon,
} from './styled';

export const CalendarStep = ({
  currentQuestion,
  generateAnswersObject,
  answerItem,
}) => {
  const [dateRange, setDateRange] = useState([null, null]);
  const [startDate, endDate] = dateRange;
  const newDate = new Date();

  const getFormattedDate = (date) => {
    if (date === null) {
      return null;
    }
    const year = date.getFullYear().toString();
    const month = `${date?.getMonth() + 1}`;
    const day = date.getDate().toString();

    return year + '-' + month + '-' + day;
  };

  const changeDateValue = (date) => {
    setDateRange(date);
    if (date[0] !== null && date[1] !== null) {
      const startDate = getFormattedDate(date[0]);
      const endDate = getFormattedDate(date[1]);
      const answer = `${startDate} : ${endDate}`;

      generateAnswersObject({
        position: currentQuestion.position,
        question: currentQuestion.question,
        selectedAnswers: [`${answer}`],
      });
    }
  };

  useEffect(() => {
    if (answerItem?.selectedAnswers?.length) {
      const date = answerItem?.selectedAnswers[0]?.split(' : ');
      if (date?.length) {
        setDateRange([new Date(date[0]), new Date(date[1])]);
      }
    } else {
      setDateRange([null, null]);
    }
  }, [currentQuestion?.position]);

  const customInput = (
    <CustomInput>
      <ExampleCustomInput>
        <CalendarIcon src={Images.calendarIcon} />
        {dateRange[0] ? getFormattedDate(dateRange[0]) : 'Start Date'}
      </ExampleCustomInput>
      <ExampleCustomInput>
        <CalendarIcon src={Images.calendarIcon} />
        {dateRange[1] ? getFormattedDate(dateRange[1]) : 'End Date'}
      </ExampleCustomInput>
    </CustomInput>
  );

  return (
    <CalendarContent>
      <QuestionText>{currentQuestion.question}</QuestionText>

      <ReactDatePicker
        minDate={newDate}
        selectsRange={true}
        startDate={startDate}
        endDate={endDate}
        customInput={customInput}
        onChange={changeDateValue}
      />
    </CalendarContent>
  );
};
